import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineCarryOut,
} from "react-icons/ai";
import { BsBuilding } from "react-icons/bs";
import { FaRocketchat } from "react-icons/fa";
import "./component.css";
import { BottomNavContainer } from "./style";

const BottomNavBar = (props) => {
  const history = useHistory();
  const [activeTabs, setActiveTabs] = useState(props.name);
  useEffect(() => {
    switch (activeTabs) {
      case "home":
        history.push("/dashboard/user/home");
        break;
      case "secretariat":
        history.push("/dashboard/user/secretariat");
        break;
      case "events":
        history.push("/dashboard/user/events");
        break;
      case "messages":
        history.push("/dashboard/user/messages");
        break;
      case "profile":
        history.push("/dashboard/profile");
        break;
      default:
        break;
    }
  }, [activeTabs, history]);

  return (
    <BottomNavContainer>
      <div className="bn-tab">
        <div>
          {activeTabs === "home" ? (
            <AiOutlineHome
              className="react-icon-style compass_color"
              size="30"
              onClick={() => setActiveTabs("home")}
            />
          ) : (
            <AiOutlineHome
              size="30"
              // color="grey"
              className="react-icon-style compass_color"
              onClick={() => setActiveTabs("home")}
            />
          )}
        </div>
        <div className="compass_color text-xs">Home</div>
      </div>
      <div className="bn-tab">
        {activeTabs === "secretariat" ? (
          <BsBuilding
            size="30"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("secretariat")}
          />
        ) : (
          <BsBuilding
            size="30"
            // color="grey"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("secretariat")}
          />
        )}
        <div className="compass_color text-xs">Secretariat</div>
      </div>
      <div className="bn-tab">
        {activeTabs === "events" ? (
          <AiOutlineCarryOut
            size="30"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("events")}
          />
        ) : (
          <AiOutlineCarryOut
            size="30"
            // color="grey"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("events")}
          />
        )}
        <div className="compass_color text-xs">Events</div>
      </div>
      <div className="bn-tab">
        {activeTabs === "messages" ? (
          <FaRocketchat
            size="30"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("messages")}
          />
        ) : (
          <FaRocketchat
            size="30"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("messages")}
          />
        )}
        <div className="compass_color text-xs">Chat</div>
      </div>
      <div className="bn-tab">
        {activeTabs === "profile" ? (
          <AiOutlineUser
            size="30"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("profile")}
          />
        ) : (
          <AiOutlineUser
            size="30"
            // color="grey"
            className="react-icon-style compass_color"
            onClick={() => setActiveTabs("profile")}
          />
        )}
        <div className="compass_color text-xs">Profile</div>
      </div>
    </BottomNavContainer>
  );
};

export default BottomNavBar;
